import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Printer, Play, Package, ClipboardCheck, CheckCircle, AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { getStatusBadge } from './lotStatusStyles';

export const LotHeader = ({
  lot,
  hasRole,
  onPrintLot,
  onPrintPhases,
  onChangeStatus,
  onOpenSimplified,
  onOpenProgress,
  onGoToTab,
  simplifiedActive,
  hasWorkPhases,
  controlsCount,
  ncsCount,
}) => {
  return (
    <>
      {/* Header */}
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-4">
          <Link to="/production-lots">
            <Button variant="ghost" size="sm" className="h-10">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Indietro
            </Button>
          </Link>
          <div>
            <div className="flex items-center gap-3">
              <h1 className="text-2xl font-bold text-slate-900 font-mono">{lot.lot_code}</h1>
              <Badge className={`${getStatusBadge(lot.status)} px-4 py-1 text-sm`}>
                {lot.status?.replace('_', ' ')}
              </Badge>
            </div>
            <p className="text-slate-500 mt-1">
              {lot.product_code} - {lot.product_name}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button onClick={onPrintLot} variant="outline" className="h-12 px-5 gap-2" data-testid="print-lot-btn">
            <Printer className="w-4 h-4" />
            Stampa commessa completa
          </Button>
          <Button onClick={onPrintPhases} variant="outline" className="h-12 px-5 gap-2 border-amber-300 text-amber-800 hover:bg-amber-50" data-testid="print-lot-phases-btn">
            <Printer className="w-4 h-4" />
            Stampa commessa per fasi
          </Button>
          {hasRole('admin', 'quality', 'production') && (
            <Button variant="outline" className="h-12 px-6 text-base" onClick={onChangeStatus} data-testid="change-status-btn">
              Cambia Stato
            </Button>
          )}
        </div>
      </div>

      {/* Quick Action Bar - Shop Floor Fast Navigation */}
      <div className="quick-action-bar" data-testid="quick-action-bar">
        {hasRole('admin', 'quality', 'production', 'operator') && simplifiedActive && (
          <Button
            onClick={onOpenSimplified}
            className="h-12 px-5 text-base bg-amber-600 hover:bg-amber-700"
            data-testid="quick-record-simplified"
          >
            <Package className="w-5 h-5 mr-2" />
            Avanzamento Semplificato
          </Button>
        )}
        {hasRole('admin', 'quality', 'production', 'operator') && hasWorkPhases && (
          <Button
            onClick={onOpenProgress}
            className="h-12 px-5 text-base bg-emerald-600 hover:bg-emerald-700"
            data-testid="quick-record-progress"
          >
            <Play className="w-5 h-5 mr-2" />
            Registra Avanzamento
          </Button>
        )}
        {hasRole('admin', 'quality', 'production', 'operator') && (
          <Link to="/qms-checks">
            <Button
              className="h-12 px-5 text-base bg-sky-600 hover:bg-sky-700"
              data-testid="quick-record-control"
            >
              <ClipboardCheck className="w-5 h-5 mr-2" />
              Registra Controllo
            </Button>
          </Link>
        )}
        <Button
          variant="outline"
          onClick={() => onGoToTab('controls')}
          className="h-12 px-5 text-base"
          data-testid="quick-view-controls"
        >
          <CheckCircle className="w-5 h-5 mr-2" />
          Controlli ({controlsCount})
        </Button>
        <Button
          variant={ncsCount > 0 ? 'destructive' : 'outline'}
          onClick={() => onGoToTab('ncs')}
          className="h-12 px-5 text-base"
          data-testid="quick-view-ncs"
        >
          <AlertTriangle className="w-5 h-5 mr-2" />
          NCs ({ncsCount})
        </Button>
      </div>
    </>
  );
};
